import { render, staticRenderFns } from "./StockMovements.vue?vue&type=template&id=55995370&"
import script from "./StockMovements.vue?vue&type=script&lang=js&"
export * from "./StockMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports